import { AgGridReact } from 'ag-grid-react';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { getDatesBetween, getFormattedValue } from '../../../../../appFunctions';
import { ColDef } from 'ag-grid-community';
import CurrentPeriodPositiveIcon from "../../../../../svg/Ads_Dashboard_Developement2/CurrentPeriodPositiveIcon/elements.svg";
import CurrentPeriodNegativeIcon from "../../../../../svg/Ads_Dashboard_Developement2/CurrentPeriodNegativeIcon/elements.svg";
import { BASE_URL, BLACK } from '../../../../../appConstants';
import { CircularProgress } from '@mui/joy';
import appError from '../../../../../appError';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import CheckedIcon from "../../../../../svg/Ads_Dashboard_Developement2/CheckedIcon/elements.svg";
import UnCheckedIcon from "../../../../../svg/Ads_Dashboard_Developement2/UnCheckedIcon/elements.svg";
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
} from 'chart.js';

type WeekProps = [number, number];
type FilterProps = {
  filter_type: string;
  period_type: string;
  month: number[];
  year: number[];
  week: WeekProps[];
  start_date: Date;
  end_date: Date;
};

type GraphTableDrawerSummaryProps = {
  setGraphTableToggle: Dispatch<SetStateAction<boolean>>;
  graphTableArr: any[];
  filter: FilterProps;
}

ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend
);
const GraphTableDrawerSummary: React.FC<GraphTableDrawerSummaryProps> = ({setGraphTableToggle, graphTableArr, filter}) => {
  const { brand_id } = useParams();

  const MatricesNameRenderer = (params: any) => {
      return (
        <div className="flex w-full px-6 py-2 items-center justify-start self-stretch gap-2">
          <div
            style={{
              color: "var(--Text-Primary-Black, #1C1C1E)",
              textAlign: "right",
              fontFamily: "Inter",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: 700,
              lineHeight: "18px",
            }}
          >
            {params?.data?.matrice_name}
          </div>
        </div>
      );
    };
    
  const CurrentRenderer = (params: any) => {
    const {
      current_period = 0,
    } = params?.data;

    return (
      <div className="flex w-full px-6 py-2 items-center justify-end self-stretch gap-2">
        <div
          className=""
          style={{
            textAlign: "center",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "18px",
          }}
        >
          {getFormattedValue(current_period)}
        </div>
      </div>
    );
  };

  const CurrentHeaderCmp = (params: any) => {
    return (
      <div
        className="flex px-6 py-2 w-full items-center justify-end self-stretch gap-2"
        style={{
          backgroundColor: "#F3F3F7",
        }}
      >
        <div
          style={{
            color: "var(--Text-Primary-Black, #1C1C1E)",
            textAlign: "end",
            fontFamily: "Inter",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "16px",
          }}
        >
          {params?.displayName}
        </div>
      </div>
    );
  };

  const [tableData, setTableData] = useState<any[]>([]); 

  const [selproduct_details_arr, setSelProduct_details_arr] = useState<string[]>(["principal_category","main_category","category","sub_category", 'product_name', 'platform_code']);
  const [loading, setLoading] = useState<boolean>(false); // Loader for Table
  const [datafetchingState, setDataFetchingState] = useState<string>("");

  const CheckboxHeaderCmp = (params: any) =>{
    return (
        <div style={{
            display: "flex",
            padding: "13px 12px 13px 12px",
            justifyContent: "start",
            alignItems: 'center',
            // backgroundColor: "#F9F9FB",
            width: "full",
            height: "100%"
        }} >
            Checkbox
        </div>
      )
  };
  const [sel_matricesGraph, setSel_matricesGraph] = useState<string[]>([]);
  const CheckboxCellRendererCmp = (params: any) =>{
    return (
        <div style={{
            display: "flex",
            padding: "8px 12px",
            justifyContent: "start",
            alignItems: "center",
            width: "fit-content",
        }} >
            {
                params?.data?.selected ? (
                    <img
                    src={CheckedIcon}
                    alt="Icon"
                    style={{ cursor: "pointer" }}
                    onClick={()=> {
                        if(sel_matricesGraph?.length > 1){
                          setTableData((prevData: any[]) => {
                            let new_data = prevData.map((item: any) =>
                              item.backend_matrice_name === params?.data?.backend_matrice_name
                                ? { ...item, selected: false }
                                : item
                            );
                            setSel_matricesGraph(new_data?.filter(item => item?.selected)?.map(item => item?.backend_matrice_name));
                            return new_data;
                            }
                          );
                        }
                        else {
                          appError("Minimum 1 matrice needs to be selected");
                        }
                      }
                    }
                    />
                ) : (
                    <img
                    src={UnCheckedIcon}
                    alt="Icon"
                    style={{ cursor: "pointer" }}
                    onClick={()=> {
                        if(sel_matricesGraph?.length < 4){
                          setTableData((prevData: any[]) =>{
                              let new_data = prevData.map((item: any) =>
                                item.backend_matrice_name === params?.data?.backend_matrice_name
                                  ? { ...item, selected: true }
                                  : item
                              );
                              setSel_matricesGraph(new_data?.filter(item => item?.selected)?.map(item => item?.backend_matrice_name));
                              return new_data;
                            }
                          )
                        } else {
                          appError("Maximum 4 matrices can be selected");
                        }
                      }
                    }
                    />
                )
            }
        </div>
      )
  };
  const fetchTableData = async (products_details_arr: string[]) => {
    const startDate = `${filter?.start_date?.getFullYear()}-${String(
      filter?.start_date?.getMonth() + 1
    ).padStart(2, "0")}-${String(filter?.start_date?.getDate()).padStart(
      2,
      "0"
    )}`;

    const endDate = `${filter?.end_date?.getFullYear()}-${String(
      filter?.end_date.getMonth() + 1
    ).padStart(2, "0")}-${String(filter?.end_date?.getDate()).padStart(
      2,
      "0"
    )}`;

    const temp_obj = {
      filter:
        filter?.filter_type === "SEGMENT" &&
        filter?.year.length > 0 &&
        filter?.month.length > 0 &&
        filter?.week.length > 0
          ? {
              filter_type: filter?.filter_type,
              year: filter?.year,
              month: filter?.month,
              week: filter?.week,
              agg_type:
                "all",
              product_detail_filter: {
                [graphTableArr[graphTableArr?.length - 1]?.type] : [graphTableArr[graphTableArr?.length - 1]?.name]
              },
            }
          : {
              filter_type: filter?.filter_type,
              start_date: startDate,

              end_date: endDate,

              agg_type:
                 "all",
              product_detail_filter: {
                [graphTableArr[graphTableArr?.length - 1]?.type] : [graphTableArr[graphTableArr?.length - 1]?.name]
              },
            },

      conditions: [],

      sort: {},

      product_detail_column: [products_details_arr],

      metrics_column: [
        "clicks",
        "impressions",
        "spend",
        "sales",
        "ad_sales_perc",
        "gross_sales",
        "gross_sales_seller",
        "gross_sales_vendor",
        "organic_sales",
        "organic_sales_perc",
        "orders",
        "units",
        "gross_units",
        "gross_units_seller",
        "gross_units_vendor",
        "organic_units",
        "acos",
        "tacos",
        "roas",
        "troas",
        "ctr",
        "cvr",
        "cpc",
        "aov",
        "cac",
        "gross_glanceviews"],
    };

    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}dashboards/adsDashboard/tableDrawer/getSalesSummary?brand_id=${brand_id}`;
      const result = await axios.post(api, temp_obj, { headers });
      const { results } = result?.data?.data;
      if (results?.length === 0) {
        setDataFetchingState("EMPTY");
      } else if (results.length > 0) {
        let initialTableData = [
          { matrice_name: "Impressions", backend_matrice_name: "impressions" },
          {
            matrice_name: "Clicks",
            backend_matrice_name: "clicks",
          },
          {
            matrice_name: "Spend",
            backend_matrice_name: "spend",
          },
          {
            matrice_name: "Ad Sales",
            backend_matrice_name: "sales",
          },
          {
            matrice_name: "Ad Sales %",
            backend_matrice_name: "ad_sales_perc",
          },
          {
            matrice_name: "Gross Sales",
            backend_matrice_name: "gross_sales",
          },
          {
            matrice_name: "Gross Sales (Seller)",
            backend_matrice_name: "gross_sales_seller",
          },
          {
            matrice_name: "Gross Sales (Vendor)",
            backend_matrice_name: "gross_sales_vendor",
          },
          {
            matrice_name: "Organic Sales",
            backend_matrice_name: "organic_sales",
          },
          {
            matrice_name: "Organic Sales %",
            backend_matrice_name: "organic_sales_perc",
          },
          {
            matrice_name: "Ad Orders",
            backend_matrice_name: "orders",
          },
          {
            matrice_name: "Ad Units",
            backend_matrice_name: "units",
          },
          {
            matrice_name: "Gross Units",
            backend_matrice_name: "gross_units",
          },
          {
            matrice_name: "Gross Units (Seller)",
            backend_matrice_name: "gross_units_seller",
          },
          {
            matrice_name: "Gross Units (Vendor)",
            backend_matrice_name: "gross_units_vendor",
          },
          {
            matrice_name: "Organic Units",
            backend_matrice_name: "organic_units",
          },
          {
            matrice_name: "ACOS",
            backend_matrice_name: "acos",
          },
          {
            matrice_name: "TACOS",
            backend_matrice_name: "tacos",
          },
          {
            matrice_name: "ROAS",
            backend_matrice_name: "roas",
          },
          {
            matrice_name: "TROAS",
            backend_matrice_name: "troas",
          },
          {
            matrice_name: "CTR",
            backend_matrice_name: "ctr",
          },
          {
            matrice_name: "CVR",
            backend_matrice_name: "cvr",
          },
          {
            matrice_name: "CPC",
            backend_matrice_name: "cpc",
          },
          {
            matrice_name: "AOV",
            backend_matrice_name: "aov",
          },
          {
            matrice_name: "CAC",
            backend_matrice_name: "cac",
          },
          {
            matrice_name: "Glance Views",
            backend_matrice_name: "gross_glanceviews",
          },
        ]
        let new_table_data:any[] = [];
        new_table_data = initialTableData.map((item) => {
          const backendName = item.backend_matrice_name;
          return {
            ...item,
            current_period: Number(results[0][`${backendName}_all`] ?? 0),
            selected: backendName === "acos" || backendName === "tacos" || backendName === "ctr" || backendName === "cvr" ? true : false
          };
        });
        setSel_matricesGraph(["impressions","clicks","spend","sales"]);
        setTableData(new_table_data);
        setDataFetchingState("SUCCESS");
      }
    } catch (error) {
      appError(error);
    } finally {
      setLoading(false);
    }
  };
  const [graphData, setGraphData] = useState<any[]>([]);
  type SummarydatesProps = {
    startDate: String,
    endDate: String
  }
  const [summarydates, setSummaryDates] = useState<SummarydatesProps[]>([]);

  const fetchGraphData = async (products_details_arr: string[]) => {
    const startDate = `${filter?.start_date?.getFullYear()}-${String(
      filter?.start_date?.getMonth() + 1
    ).padStart(2, "0")}-${String(filter?.start_date?.getDate()).padStart(
      2,
      "0"
    )}`;

    const endDate = `${filter?.end_date?.getFullYear()}-${String(
      filter?.end_date.getMonth() + 1
    ).padStart(2, "0")}-${String(filter?.end_date?.getDate()).padStart(
      2,
      "0"
    )}`;

    const temp_obj = {
      filter:
        filter?.filter_type === "SEGMENT" &&
        filter?.year.length > 0 &&
        filter?.month.length > 0 &&
        filter?.week.length > 0
          ? {
              filter_type: filter?.filter_type,
              year: filter?.year,
              month: filter?.month,
              week: filter?.week,
              agg_type:
                "day",
              product_detail_filter: {
                [graphTableArr[graphTableArr?.length - 1]?.type] : [graphTableArr[graphTableArr?.length - 1]?.name]
              },
            }
          : {
              filter_type: filter?.filter_type,
              start_date: startDate,

              end_date: endDate,

              agg_type:
                 "day",
              product_detail_filter: {
                [graphTableArr[graphTableArr?.length - 1]?.type] : [graphTableArr[graphTableArr?.length - 1]?.name]
              },
            },

      conditions: [],

      sort: {},

      product_detail_column: [products_details_arr],

      metrics_column: [
        "clicks",
        "impressions",
        "spend",
        "sales",
        "ad_sales_perc",
        "gross_sales",
        "gross_sales_seller",
        "gross_sales_vendor",
        "organic_sales",
        "organic_sales_perc",
        "orders",
        "units",
        "gross_units",
        "gross_units_seller",
        "gross_units_vendor",
        "organic_units",
        "acos",
        "tacos",
        "roas",
        "troas",
        "ctr",
        "cvr",
        "cpc",
        "aov",
        "cac",
        "gross_glanceviews"],
    };

    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}dashboards/adsDashboard/tableDrawer/getSalesSummary?brand_id=${brand_id}`;
      const result = await axios.post(api, temp_obj, { headers });
      const { results } = result?.data?.data;
      if (results?.length === 0) {
        setDataFetchingState("EMPTY");
      } else if (results.length > 0) {

        let dates: string[] = [];

        if(filter?.filter_type === "TIMELINE"){
          dates = getDatesBetween(startDate, endDate);

        } else if(filter?.filter_type === "SEGMENT"){
          let new_arr = [];
          for (let y of filter?.year) {
            for (let m of filter?.month) {
                for (let [ws, we] of filter?.week) {
                    let startDate = String(y) + "-" + String(m).padStart(2, "0") + "-" + String(ws).padStart(2, "0");
                    let endDate = String(y) + "-" + String(m).padStart(2, "0") + "-" + String(we).padStart(2, "0");
                    dates.push(...getDatesBetween(startDate, endDate));
                    new_arr.push({startDate, endDate});
                }
            }
          }
          setSummaryDates(new_arr);
        }

        const new_table_data: string[] = dates.map(date => {
          const [year, month, d] = date.split('-');
          const dataPoint: any = { label: `${d}-${month}-${year}` };
      
          results.forEach((row: any) => {
            Object.entries(row).forEach(([key, value]) => {
              if (key.endsWith(`_${date}`)) {
                const metric = key.replace(`_${date}`, "");
                dataPoint[metric] = value;
              }
            });
          });
      
          return dataPoint;
        });
        setGraphData(new_table_data);
        setDataFetchingState("SUCCESS");
      }
    } catch (error) {
      appError(error);
    } finally {
      setLoading(false);
    }
  };

  console.log('-->', summarydates);
  const verticalcolDefs: ColDef<any>[] = [
    {
      field: "selected",
      headerName: "Checkbox",
      sortable: false,
      cellRenderer: CheckboxCellRendererCmp,
      headerComponent: CheckboxHeaderCmp,
      headerClass: 'custom-header-style',
      // cellStyle: {padding: '0px', backgroundColor: "#FFF"}
      minWidth: 100,
      flex: 1
    },
      {
        field: "matrice_name",
        headerName: "Matrices",
        sortable: false,
        cellRenderer: MatricesNameRenderer,
        // headerComponent: MatriceNameHeaderCmp,
        minWidth: 170,
        flex: 2
      },
      {
        field: "current_period",
        headerName: "Current Period",
        sortable: false,
        cellRenderer: CurrentRenderer,
        headerComponent: CurrentHeaderCmp,
        minWidth: 150,
        flex: 2
      },
    ];

  useEffect(()=>{

    fetchTableData(graphTableArr[graphTableArr?.length - 1]?.type);
    fetchGraphData(graphTableArr[graphTableArr?.length - 1]?.type);

  },[graphTableArr[graphTableArr?.length - 1]?.name]);

  const colorArray = ["#FF6B6B", "#4ECDC4", "#FFD93D", "#1A535C"];

  const yAxes = sel_matricesGraph.reduce((acc, metric, index) => {
    acc[`${metric}Axis`] = {
      type: 'linear',
      position: index % 2 === 0 ? 'left' : 'right',
      display: true,
      ticks: { color: colorArray[index] },
      grid: {
        drawOnChartArea: index === 0, // show grid only for first axis
      },
    };
    return acc;
  }, {} as any);

  const formateDate = (ip_date: Date) => {
    return `${String(ip_date?.getDate()).padStart(
      2,
      "0"
    )}/${String(ip_date?.getMonth() + 1
    ).padStart(
      2,
      "0"
    )}/${ip_date?.getFullYear()}`
  }

  const formateStringDate = (ip_date: String) => {
    const [year, month, date] = ip_date.split('-');
    return `${date.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
  }

  return (
      <div className='h-full w-full'> 
      {loading ? (
        <div className='h-full w-full flex justify-center items-center'>
          <CircularProgress />
        </div>
      ): (
        <>
          <div
          className="flex py-2 px-3 items-center justify-between gap-2"
          style={{
              height: 72,
              borderBottom: `1px solid #EAEAED`,
              backgroundColor: "white",
          }}
          >
            <div className="h-full flex justify-between items-start w-full gap-2">
            <div
                className="self-stretch"
                style={{
                fontSize: 12,
                fontWeight: 500,
                lineHeight: "16px",
                color: BLACK.B_100,
                // flexGrow: 1
                width: "60%"
                }}
            >
                {graphTableArr?.filter(item => selproduct_details_arr.includes(item?.type)).map((item,index) => {
                  if(index === graphTableArr?.filter(item => selproduct_details_arr.includes(item?.type))?.length - 1){
                    return `${item?.name}`;
                  }
                  else {
                    return `${item?.name} > `;
                  }
                })}
            </div>
            
            <div
              className="flex h-fit items-center py-1 px-2 rounded-[4px]"
              style={{
                border: "1px solid #EAEAED",
                position: "relative",
                maxWidth: '35%'
                // alignSelf: "center",
              }}
            >
              <div className="flex items-center gap-2 h-fit">
                <div
                  style={{
                    color: "var(--Text-Primary-Black, #1C1C1E)",
                    fontFamily: "Inter",
                    fontSize: "10px",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "14px",
                    textWrap: "wrap",
                  }}
                >
                  {filter?.filter_type === 'TIMELINE' ? (
                  `${formateDate(filter?.start_date)} - ${formateDate(filter?.end_date)}`) : (
                    summarydates?.map((item, index) => (
                      `${formateStringDate(item?.startDate)} - ${formateStringDate(item?.endDate)}${index === summarydates?.length - 1 ? "" : ', '} `
                    ))
                  )}
                </div>
                
              </div>
              {/* <img
                src={CalenderIcon}
                alt="OverView Icon"
                style={{ cursor: "pointer" }}
                // onClick={() => setDateToggle(true)}
              /> */}
            </div>
          </div>
            <div className="flex justify-between items-center gap-2">
                <div
                className="w-fit cursor-pointer"
                onClick={() => {
                    setGraphTableToggle(false);
                }}
                >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                >
                    <path
                    d="M19.2806 18.2194C19.3502 18.289 19.4055 18.3718 19.4432 18.4628C19.4809 18.5539 19.5003 18.6514 19.5003 18.75C19.5003 18.8485 19.4809 18.9461 19.4432 19.0372C19.4055 19.1282 19.3502 19.2109 19.2806 19.2806C19.2109 19.3503 19.1281 19.4056 19.0371 19.4433C18.9461 19.481 18.8485 19.5004 18.7499 19.5004C18.6514 19.5004 18.5538 19.481 18.4628 19.4433C18.3717 19.4056 18.289 19.3503 18.2193 19.2806L11.9999 13.0603L5.78055 19.2806C5.63982 19.4213 5.44895 19.5004 5.24993 19.5004C5.05091 19.5004 4.86003 19.4213 4.7193 19.2806C4.57857 19.1399 4.49951 18.949 4.49951 18.75C4.49951 18.551 4.57857 18.3601 4.7193 18.2194L10.9396 12L4.7193 5.78061C4.57857 5.63988 4.49951 5.44901 4.49951 5.24999C4.49951 5.05097 4.57857 4.8601 4.7193 4.71936C4.86003 4.57863 5.05091 4.49957 5.24993 4.49957C5.44895 4.49957 5.63982 4.57863 5.78055 4.71936L11.9999 10.9397L18.2193 4.71936C18.36 4.57863 18.5509 4.49957 18.7499 4.49957C18.949 4.49957 19.1398 4.57863 19.2806 4.71936C19.4213 4.8601 19.5003 5.05097 19.5003 5.24999C19.5003 5.44901 19.4213 5.63988 19.2806 5.78061L13.0602 12L19.2806 18.2194Z"
                    fill="#1C1C1C"
                    />
                </svg>
                </div>
            </div>
          </div>
          <div className="flex w-full p-3 gap-3 flex-col items-start self-stretch" style={{
            height: "calc(100vh - 72px)"
          }}>
            <div className="h-[50%]" style={{width: "100%"}}>
              <Line data={{
                labels: graphData?.map(item => item?.label),
                datasets: sel_matricesGraph?.map((metric, index) => ({
                  label: metric,
                  data: graphData?.map(item => item[metric]),
                  backgroundColor: colorArray[index],
                  borderColor: colorArray[index],
                  yAxisID: `${metric}Axis`
                }))
              }}
                options={{
                  responsive: true,
                  maintainAspectRatio: false,
                  interaction: {
                    mode: 'index' as const,
                    intersect: false,
                  },
                  // stacked: false,
                  scales: yAxes,
                }}
              />
            </div>
            <div className="w-full h-[50%]">
                <div className="ag-theme-quartz" style={{
                width: "100%",
                height: "100%"
                }}>
                <AgGridReact
                    rowData={tableData}
                    columnDefs={verticalcolDefs}
                    rowHeight={32}
                    headerHeight={36}
                    getRowId={(params) => params.data.backend_matrice_name} // Must provide a unique ID
                />
                </div>
            </div>
          </div>
        </>)}
      </div>
  )
}

export default GraphTableDrawerSummary